<template>
  <div>
    <div class="top-window">
      <div class="heading1 heading1-line">Статистика</div>
    </div>
    <Spinner v-if="isLoading" size="large" />

    <transition name="fade">
      <div v-if="!isLoading">
        <template v-if="stats.length">
          <div
            v-for="month in stats"
            :key="month.month"
            class="month-plan"
          >
            <div class="top-window between">
              <div class="h4 h4-mb0">
                {{ month.month }}: {{ month.orders }} на <strong>{{ month.earned }} ₽</strong>
              </div>
            </div>
            <ul v-if="month.employees && month.employees.length" class="stat-list">
              <li
                v-for="employee in month.employees"
                :key="employee.name"
                class="stat-item"
              >
                <div>{{ employee.name }}: {{ employee.orders }} на <strong>{{ employee.earned }} &nbsp;₽</strong></div>
              </li>
            </ul>

            <!--<a href="#" class="btn-line btn-mt w-inline-block">
              <div class="icon-16px icon-btn-center w-embed">
                <DocumentIcon />
              </div>
              <div>Полный список</div>
            </a>-->
          </div>
        </template>
        <template v-else>
          <div class="h4 h4-mb0">
            Недостаточно данных для анализа.
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
  // import DocumentIcon from '@/icons/document.svg';
  import parseError from '@/utils/api/parse-error';
  import factory from '@/utils/api/factory';
  import Spinner from 'vue-simple-spinner';
  import monthFormat from '@/utils/formatting/month-format';
  import declOfNum from '@/utils/formatting/decl-of-num';
  import addSpaces from '@/utils/formatting/add-spaces';

  export default {
    name: 'Statistics',
    components: {
      // DocumentIcon,
      Spinner,
    },
    data () {
      return {
        error: null,
        isLoading: false,
        stats: [],
      };
    },
    created () {
      this.load();
    },
    methods: {
      async load () {
        try {
          this.isLoading = true;
          const {data} = await factory('laboratory').indexInPath('stats');
          this.stats = Object.keys(data).map(key => ({
            month: monthFormat(key),
            orders: `${data[key]?.total?.count || 0} ${declOfNum(data[key]?.total?.count || 0, ['заказ', 'заказа', 'заказов'])}`,
            earned: addSpaces(data[key]?.total?.earned),
            employees: data[key]?.users?.map(employee => ({
              name: employee.name,
              orders: `${employee.count} ${declOfNum(employee.count, ['заказ', 'заказа', 'заказов'])}`,
              earned: addSpaces(employee.earned),
            })),
          }));
          this.isLoading = false;
        } catch (e) {
          this.error = parseError(e) || 'Что-то пошло не так.';
          this.isLoading = false;
        }
      },
    },
  };
</script>
